import onboardingConfigReducer from "../onboardingConfigReducer";
import onboardingSponsorConfigReducer from "../onboardingSponsorConfigReducer";

const onboardingReducers = {
  onboardingConfig: onboardingConfigReducer,
  onboardingSponsorConfig: onboardingSponsorConfigReducer,
};

export default onboardingReducers;

